import { createSelector } from '@reduxjs/toolkit'
import { TRootState } from 'store/types'
import { IAiLibImageListParams } from 'store/types/aiLibImage'

const selector = (state: TRootState) => state.aiLibImage

const isFiltersOpen = createSelector(selector, state => state.isFiltersOpen)
const filters = createSelector(selector, state => state.filters)
const isLoaded = createSelector(selector, state => state.isLoaded)
const isInitialLoading = createSelector(
  selector,
  state => state.isInitialLoading
)
const isLoadingMore = createSelector(selector, state => state.isLoadingMore)
const historyList = createSelector(selector, state => state.historyList)
const historyTotalCount = createSelector(
  selector,
  state => state.historyTotalCount
)

const isHistoryScopedToCurrentProject = createSelector(
  filters,
  state => state.isHistoryScopedToCurrentProject
)
const selectedModelCode = createSelector(filters, state => state.modelCode)
const selectedAspectRatio = createSelector(filters, state => state.aspectRatio)
const selectedStyleId = createSelector(filters, state => state.styleId)
const selectedImageType = createSelector(filters, state => state.imageType)

const hasActiveFilters = createSelector(filters, state => {
  const {
    modelCode,
    aspectRatio,
    styleId,
    imageType,
    isHistoryScopedToCurrentProject
  } = state
  return !!(
    modelCode ||
    aspectRatio ||
    styleId ||
    imageType ||
    isHistoryScopedToCurrentProject
  )
})

const activeFiltersCount = createSelector(filters, state => {
  const {
    modelCode,
    aspectRatio,
    styleId,
    imageType,
    isHistoryScopedToCurrentProject: isScoped
  } = state

  return [modelCode, aspectRatio, styleId, imageType, isScoped].filter(Boolean)
    .length
})

const activeFilters = createSelector(
  filters,
  (filters): Partial<IAiLibImageListParams> => {
    const { modelCode, aspectRatio, styleId, imageType } = filters

    return {
      model: modelCode ?? undefined,
      aspectRatio: aspectRatio ?? undefined,
      styleId: styleId ?? undefined,
      imageType: imageType ?? undefined
    }
  }
)

export const aiLibImageSelectors = {
  isFiltersOpen,
  filters,
  hasActiveFilters,
  activeFiltersCount,
  selectedModelCode,
  selectedAspectRatio,
  selectedStyleId,
  selectedImageType,
  isLoaded,
  isInitialLoading,
  isLoadingMore,
  historyList,
  historyTotalCount,
  isHistoryScopedToCurrentProject,
  activeFilters
}
